import React from "react";
import { Controller } from "react-hook-form";

const BasicInfoForm = ({ control, errors }) => {
  return (
    <div className="wizard-step-content">
      <h3 className="step-title">Basic Information</h3>
      <p className="step-subtitle">Enter the basic details for your campaign</p>
      <div className="cw-form-grid-2">
        <div className="cw-form-field">
          <label className="cw-form-label">Campaign Name *</label>
          <Controller
            name="campaign_name"
            control={control}
            render={({ field }) => (
              <input
                {...field}
                type="text"
                className="cw-form-input"
                placeholder="e.g., Q1 Loan Recovery Campaign"
              />
            )}
          />
          {errors.campaign_name && (
            <span className="cw-error-text">{errors.campaign_name.message}</span>
          )}
        </div>

        <div className="cw-form-field">
          <label className="cw-form-label">Description</label>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <textarea
                {...field}
                className="cw-form-textarea"
                placeholder="Brief description of the campaign"
                rows={3}
              />
            )}
          />
          {errors.description && (
            <span className="cw-error-text">{errors.description.message}</span>
          )}
        </div>
      </div>

      <div className="cw-form-grid-2">
        <div className="cw-form-field">
          <label className="cw-form-label">Start Time</label>
          <div className="cw-time-input-group">
            <Controller
              name="start_hour"
              control={control}
              render={({ field }) => (
                <select {...field} className="cw-form-select">
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i} value={String(i + 1).padStart(2, "0")}>
                      {String(i + 1).padStart(2, "0")}
                    </option>
                  ))}
                </select>
              )}
            />
            <span className="cw-time-separator">:</span>
            <Controller
              name="start_minute"
              control={control}
              render={({ field }) => (
                <select {...field} className="cw-form-select">
                  {Array.from({ length: 60 }, (_, i) => (
                    <option key={i} value={String(i).padStart(2, "0")}>
                      {String(i).padStart(2, "0")}
                    </option>
                  ))}
                </select>
              )}
            />
            <Controller
              name="start_am_pm"
              control={control}
              render={({ field }) => (
                <select {...field} className="cw-form-select">
                  <option value="AM">AM</option>
                  <option value="PM">PM</option>
                </select>
              )}
            />
          </div>
        </div>
        <div className="cw-form-field">
          <label className="cw-form-label">End Time</label>
          <div className="cw-time-input-group">
            <Controller
              name="end_hour"
              control={control}
              render={({ field }) => (
                <select {...field} className="cw-form-select">
                  {Array.from({ length: 12 }, (_, i) => (
                    <option key={i} value={String(i + 1).padStart(2, "0")}>
                      {String(i + 1).padStart(2, "0")}
                    </option>
                  ))}
                </select>
              )}
            />
            <span className="cw-time-separator">:</span>
            <Controller
              name="end_minute"
              control={control}
              render={({ field }) => (
                <select {...field} className="cw-form-select">
                  {Array.from({ length: 60 }, (_, i) => (
                    <option key={i} value={String(i).padStart(2, "0")}>
                      {String(i).padStart(2, "0")}
                    </option>
                  ))}
                </select>
              )}
            />
            <Controller
              name="end_am_pm"
              control={control}
              render={({ field }) => (
                <select {...field} className="cw-form-select">
                  <option value="AM">AM</option>
                  <option value="PM">PM</option>
                </select>
              )}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfoForm;
